import { EventComponent, PlannerEcsSystem } from '@inter-ikea-storageone/range';
import { checkAndReplaceEntities } from '../../functions/ShelfSystemUtils';
export class FourPackShelvesSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'FourPackShelfSystem', EventComponent.id);
        this.products = [];
        this.doingChangesOnComponent = [];
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    setMarketProducts(marketProducts) {
        this.products = marketProducts;
    }
    onAdd(_entity, _newComponent) { }
    onRemove(_entity, _oldComponent) { }
    onUpdate(_entity, _oldComponent, newComponent) {
        if (newComponent.typeId === EventComponent.id &&
            ['history', 'load'].includes(newComponent.event)) {
            this.coreApi.getSystem('HistoryEventSystem')?.disable();
            checkAndReplaceEntities(this.coreApi, this.products);
            this.coreApi.getSystem('HistoryEventSystem')?.enable();
        }
    }
}
//# sourceMappingURL=FourPackShelvesSystem.js.map